// ----------------------------------------------------------------------
// <copyright file="Izenda.Destination.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Destination component
 */
!(function () {
  var m = require('mobx');
  var React = require('react');
  var EventUtils = require('EventUtils');
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');

  var constants = require('logic/data/Izenda.CopyManagementConstants');

  var Panel = require('share/components/controls/Izenda.Panel');
  var List = require('share/components/controls/Izenda.List');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var Select = Validator()(require('share/components/controls/multiSelectBox/Izenda.Select'));
  var Table = require('share/components/controls/DataGrid/Izenda.Table').Table;
  var Column = require('share/components/controls/DataGrid/Izenda.Table').Column;
  var Dimensions = require('share/components/hoc/Izenda.Dimensions');
  const { isEmpty, isNil } = require('lodash/fp');

  var DestinationGrid = React.createClass({
    render: function () {
      var props = this.props;
      var store = props.store;
      var localization = props.localization;
      var height = props.height;
      var item = store.item;
      var dataSourceGrid = item.workspaceTenants;
      var TABLE_DEF = constants.TABLE_DESTINATION_DEFINITION;
      var tableClassName = classnames('default-table u_fullHeight u_fullWidth u_noBorder', {
        'hidden' :  isNil(item.selectedDestinationTenantIDs)
      });

      return (
        ! isEmpty(dataSourceGrid) &&
        <div className='u_tableCell'>
          {localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_DESTINATION_GRID')}
          <Panel className='izenda-CopyManagementDestinationGrid u_borderAll'>
            <Table
              dataSource={dataSourceGrid}
              onSortChange={this.onSortChange}
              sortInfo={item.pageInfo.colSortDirs}
              className={tableClassName}
              minHeight={362}
              maxHeight={362}>
              <Column
                {...TABLE_DEF['tenantName']}
                cell={this.renderTenant} />

              <Column
                {...TABLE_DEF['status']}
                cell={this.renderStatus} />

              <Column
                {...TABLE_DEF['action']}
                cell={this.renderActionColumn} />
            </Table>
          </Panel>
        </div>
      );
    },
    /**
     * Render tenant cell
     */
    renderTenant : function (dataRow, key) {
      return <div className="overflow-text">{dataRow[key]}</div>;
    },
    /**
     * Rendern status cell
     */
    renderStatus : function (dataRow, key) {
      var dataRowKey = constants.STATUS_OF_DESTINATION[dataRow[key]];
      var colorSetting = dataRowKey.class;
      return (
        <div>
          <span className={classnames('u_inline', colorSetting)}>{dataRowKey.status}</span>
          <span className={dataRowKey.iconClass} title={constants.VALIDATION_ERROR_TOOLTIP}></span>
        </div>);
    },
    /**
     * Render tenant action column
     */
    renderActionColumn: function (dataRow, key, rowIndex, column) {
      var props = this.props;
      var dataRowKey = constants.STATUS_OF_DESTINATION[dataRow[key]];
      var colorSetting = dataRowKey.iconOkClass;
      var localization = props.localization;
      var loader = props.loader;
      var store = props.store;
      var goToTenantMode = function (tenant) {
        return store.goToTenantMode(tenant)
                    .finally(loader.endLoading.bind(loader));
      };
      var gotoAdvancedMode =  function (tenant) {
        loader.startLoading();
        if (tenant.status !== constants.STATUS_OF_DESTINATION.NEED_VALIDATION) {
          this.onValidate.bind(this, tenant)().then(goToTenantMode.bind(this, tenant));
        } else {
          goToTenantMode(tenant);
        }
      };

      return (
        <div>
          <a onClick={this.onValidate.bind(this, dataRow)}>
            <span title={localization.getText("COMMON_LABEL_VALIDATE")} className={classnames('icon-ok', colorSetting)}/>
          </a>
          <a onClick={gotoAdvancedMode.bind(this, dataRow)}>
            <span title={localization.getText("COPY_MANAGEMENT_LABEL_ADVANCED_SETTINGS")} className='icon-setting' />
          </a>
          <a onClick={this.onDelete.bind(this, dataRow)} >
            <span title={localization.getText("COMMON_LABEL_DELETE")} className='icon-cancel' />
          </a>
        </div>
      );
    },
    onSortChange : function (columnKey, sortDir) {
      var item = this.props.item;
      item.onSortChange(columnKey, sortDir);
    },
    /**
     * on Validate a workspace tenant
     * @param  {object} dataRow
     * @return {[type]}         [description]
     */
    onValidate : function (tenant) {
      var props = this.props;
      var store = props.store;
      var loader = props.loader;
      var valManager = props.validation;

      loader.startLoading();
      return store.validateWorkspaceTenant(tenant, true)
                  .then(function(result) {
                    if (! isEmpty(result.messages)) {
                      if (! isEmpty(result.messages[0].key)) {
                        valManager.updateErrors(result.messages);
                      } else {
                        return props.confirmFn('Confirmation', {
                          description: result.messages[0].messages[0],
                          showCancel: false
                        }).then(function () {
                          loader.startLoading();
                          return store.handleAfterConcurrency(result.messages[0].detail)
                                      .finally(loader.endLoading.bind(loader));
                        });
                      }
                    }
                  }).finally(loader.endLoading.bind(loader));
    },
    /**
     * Delete a tenant destination
     */
    onDelete : function (tenant, e) {
      var props = this.props;
      var loader = props.loader;
      var item = props.store.item;

      e.stopPropagation();
      props.confirmFn('Confirmation', {
        description: String.format(constants.M11, tenant.tenantName)
      }).then(function () {
        loader.startLoading();
        item.deleteDestinationTenant(tenant);
        return props.store.loadDistinctConnections().finally(loader.endLoading.bind(loader));
      });
    }
  });

  module.exports = connect(Dimensions)(DestinationGrid);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceDestination/DestinationGrid/Izenda.DestinationGrid.jsx